import script from "./chart_dominance.vue?vue&type=script&setup=true&lang=js"
export * from "./chart_dominance.vue?vue&type=script&setup=true&lang=js"

import "./chart_dominance.vue?vue&type=style&index=0&id=5a61216a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a61216a"]])

export default __exports__